// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_os-0";